var map = {
	"./logo1.webp": 1104,
	"./logo2.webp": 5773,
	"./logo3.webp": 834,
	"./logo4.webp": 6735,
	"./logo5.webp": 2444,
	"./logo6.webp": 9305,
	"./logo7.webp": 4798,
	"./logo8.webp": 2987,
	"./logo9.webp": 9256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9958;